import React from 'react';
import { Formik } from 'formik';
import {
  IonContent,
  IonFooter,
  IonButton,
  IonLabel,
  IonList,
  IonItem,
  IonSpinner
} from '@ionic/react';
import { BasicInput } from 'src/components/Field';
import StageBar from 'src/components/StageBar';
import yup from 'src/feathers/yup';
import app from 'src/feathers';
import alerts from 'src/lib/alerts';

class DocumentUploadItem extends React.Component {
  state = { isUploading: false };

  handleUploadClick = () => {
    this.input.value = null;
    this.input.click();
  };

  handleImageChange = (event) => {
    this.setState({ isUploading: true });
    const job_id = this.props.jobId;
    const file = Array.from(event.target.files)[0];
    const formData = new FormData();
    formData.append('file', file);
    formData.append('job_id', job_id);
    app
      .service('api/job-documents')
      .create(formData)
      .then((newDocument) => {
        this.setState({ isUploading: false });
        if (this.props.onChange) {
          this.props.onChange(newDocument);
        }
      })
      .catch((err) => {
        alerts.errors(err);
        this.setState({ isUploading: false });
      });
  };

  render() {
    const { question, disabled } = this.props;
    const { isUploading } = this.state;
    return (
      <IonItem disabled={disabled}>
        <input
          type="file"
          accept=".jpg, .png, .pdf, .jpeg"
          style={{ display: 'none' }}
          ref={(ref) => (this.input = ref)}
          onChange={this.handleImageChange}
        />
        <IonLabel>
          {question.label}
          {question.document && <p>{question.document.original_name}</p>}
        </IonLabel>
        <IonButton
          slot="end"
          fill="clear"
          disabled={disabled}
          onClick={this.handleUploadClick}
        >
          {isUploading ? <IonSpinner /> : 'Upload'}
        </IonButton>
      </IonItem>
    );
  }
}

export default class StageMilestone extends React.Component {
  validationSchema = yup.object({
    questions: yup.array().of(
      yup.object({
        answer: yup.mixed().required('Required')
      })
    )
  });

  handleSubmit = (data, formik) => {
    this.props.nextStage(data).catch(alerts.errors);
  };

  render() {
    const {
      fetching,
      job,
      stage,
      stageContainer,
      startBreak,
      endBreak
    } = this.props;
    const { questions } = stage;
    return (
      <Formik
        initialValues={{ questions }}
        validationSchema={this.validationSchema}
        onSubmit={this.handleSubmit}
        render={({ values, submitForm, isValid, setFieldValue }) => {
          return (
            <React.Fragment>
              <IonContent>
                <StageBar
                  job={job}
                  stage={stage}
                  stageContainer={stageContainer}
                  onStartBreak={startBreak}
                  onEndBreak={endBreak}
                  fetching={fetching}
                />
                <IonList lines="full" className="ion-no-margin ion-no-padding">
                  {values.questions.map((question, index) => {
                    if (question.type === 'job_document_id') {
                      return (
                        <DocumentUploadItem
                          jobId={job._id}
                          key={index}
                          question={question}
                          onChange={(newDocument) => {
                            setFieldValue(`questions[${index}]`, {
                              ...question,
                              answer: newDocument._id,
                              document: newDocument
                            });
                          }}
                          disabled={fetching}
                        />
                      );
                    }
                    return (
                      <IonItem key={index}>
                        <IonLabel
                          position={
                            question.type === 'checkbox' ? '' : 'stacked'
                          }
                        >
                          {question.label}
                        </IonLabel>
                        <BasicInput
                          name={`questions[${index}].answer`}
                          type={question.type}
                          disabled={fetching}
                        />
                      </IonItem>
                    );
                  })}
                </IonList>
              </IonContent>
              <IonFooter>
                <IonButton
                  onClick={submitForm}
                  disabled={!isValid || fetching}
                  expand="full"
                  className="ion-no-margin"
                  color="success"
                >
                  {fetching ? <IonSpinner /> : 'Next Stage'}
                </IonButton>
              </IonFooter>
            </React.Fragment>
          );
        }}
      />
    );
  }
}
